import { BUBBLE_SIZE, DEFAULT_MARGIN, MOBILE_DEFAULT_BOTTOM, POSITION_STORAGE_KEY } from "./constants";

export interface Position {
  x: number;
  y: number;
}

/**
 * Get the default position for the feedback bubble.
 * On mobile, positions higher to avoid navbar overlap.
 */
export function getDefaultPosition(isMobile: boolean): Position {
  if (typeof window === "undefined") {
    return { x: DEFAULT_MARGIN, y: MOBILE_DEFAULT_BOTTOM };
  }
  return {
    x: DEFAULT_MARGIN,
    y: isMobile ? MOBILE_DEFAULT_BOTTOM : 24,
  };
}

/**
 * Retrieve saved position from localStorage.
 * Returns null if no position is saved or if parsing fails.
 */
export function getSavedPosition(): Position | null {
  if (typeof window === "undefined") return null;
  const saved = localStorage.getItem(POSITION_STORAGE_KEY);
  if (saved) {
    try {
      return JSON.parse(saved) as Position;
    } catch {
      return null;
    }
  }
  return null;
}

/**
 * Save position to localStorage.
 */
export function savePosition(position: Position): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(POSITION_STORAGE_KEY, JSON.stringify(position));
}

/**
 * Clamp position to keep bubble within viewport bounds.
 */
export function clampPosition(pos: Position): Position {
  if (typeof window === "undefined") return pos;
  const maxX = window.innerWidth - BUBBLE_SIZE - DEFAULT_MARGIN;
  const maxY = window.innerHeight - BUBBLE_SIZE - DEFAULT_MARGIN;
  return {
    x: Math.max(DEFAULT_MARGIN, Math.min(pos.x, maxX)),
    y: Math.max(DEFAULT_MARGIN, Math.min(pos.y, maxY)),
  };
}
